(() => {
  const formByLocale = {
    en: { id: 'Tn7GfN', label: '🎁 REWARDS' },
    pl: { id: 'Ty8Vhg', label: '🎁 NAGRODY' },
    es: { id: 'Vzq5w6', label: '🎁 RECOMPENSAS' },
    it: { id: 'SzykXe', label: '🎁 RICOMPENSE' },
    de: { id: 'Wd2nb5', label: '🎁 BELOHNUNGEN' },
    fr: { id: 'WSDEYz', label: '🎁 RÉCOMPENSES' }
  };
  const firstPathPart = window.location.pathname.split('/').filter(Boolean)[0]?.toLowerCase();
  const locale = ['pl', 'es', 'it', 'de', 'fr'].find((code) =>
    firstPathPart === code || firstPathPart === `${code}-${code}`
  ) || 'en';
  const form = formByLocale[locale];
  const knownFormIds = new Set(Object.values(formByLocale).map(({ id }) => id));
  const storageKey = 'esthedepot-halloween-2026-teaser-submitted';
  const activatedKey = `esthedepot-halloween-2026-teaser-activated-${form.id}`;
  const rewardsByLocale = {
    en: { title: 'Your BF Rewards Are Ready!', description: 'Use the code that matches your order at checkout:', close: 'Close rewards' },
    pl: { title: 'Twoje kody są gotowe!', description: 'Podczas finalizacji zamówienia użyj kodu pasującego do Twojego zamówienia:', close: 'Zamknij nagrody' },
    es: { title: '¡Tus códigos están listos!', description: 'Al pagar, usa el código que corresponda a tu pedido:', close: 'Cerrar recompensas' },
    it: { title: 'I tuoi codici sono pronti!', description: 'Al pagamento, usa il codice adatto al tuo ordine:', close: 'Chiudi le ricompense' },
    de: { title: 'Deine Codes sind da!', description: 'Nutze beim Bezahlen den passenden Code:', close: 'Prämien schließen' },
    fr: { title: 'Vos codes sont prêts !', description: 'Au paiement, utilisez le code adapté à votre commande :', close: 'Fermer les récompenses' }
  };
  const rewardImageByLocale = {
    en: 'https://cdn.klaviyomail.com/company/QUhUpp/images/15ad9dfb-9628-4858-badc-8bdad3b4534a.jpeg',
    pl: 'https://cdn.klaviyomail.com/company/QUhUpp/images/014feb77-eca3-429d-add9-95ef78be40bb.jpeg',
    es: 'https://cdn.klaviyomail.com/company/QUhUpp/images/5e70ab82-98c4-4bc5-bc9b-048b2d48b9ed.jpeg',
    it: 'https://cdn.klaviyomail.com/company/QUhUpp/images/266fd1b9-7694-41e9-b600-e4b1b913940b.jpeg',
    de: 'https://cdn.klaviyomail.com/company/QUhUpp/images/6408c36a-6d7d-4995-a99e-06f01c84e1d8.jpeg',
    fr: 'https://cdn.klaviyomail.com/company/QUhUpp/images/45549d8a-c901-4d7b-acb2-df5e195e78c0.jpeg'
  };
  let submitted = false;
  let activated = false;
  let formOpen = false;
  let button;
  let rewardOverlay;
  let fitLabel;
  let priorFocus;
  let priorOverflow;

  try {
    submitted = window.localStorage.getItem(storageKey) === '1';
    activated = window.sessionStorage.getItem(activatedKey) === '1';
  } catch (_) {
    // Keep the tab working for this page if storage is unavailable.
  }

  const render = () => {
    if (!button) return;
    const show = (submitted || activated) && !formOpen && rewardOverlay.hidden;
    const wasHidden = button.hidden;
    button.hidden = !show;
    if (show && wasHidden) {
      window.requestAnimationFrame(() => {
        if (!button.hidden) fitLabel?.();
      });
    }
  };

  const closeRewards = () => {
    if (rewardOverlay.hidden) return;
    rewardOverlay.hidden = true;
    document.body.style.overflow = priorOverflow;
    render();
    priorFocus?.focus();
  };

  const openRewards = () => {
    priorFocus = document.activeElement;
    priorOverflow = document.body.style.overflow;
    rewardOverlay.hidden = false;
    document.body.style.overflow = 'hidden';
    render();
    rewardOverlay.querySelector('.esthe-halloween-reward-close').focus();
  };

  window.addEventListener('klaviyoForms', (event) => {
    const detail = event.detail || {};
    if (!knownFormIds.has(detail.formId)) return;

    if (detail.type === 'submit') {
      submitted = true;
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (_) {
        // Persistence is optional; the current page still keeps the tab.
      }
    }
    if (detail.formId !== form.id) return;
    if (detail.type === 'open') formOpen = true;
    if (detail.type === 'close') {
      formOpen = false;
      activated = true;
      try {
        window.sessionStorage.setItem(activatedKey, '1');
      } catch (_) {
        // Keep the tab working for this page if storage is unavailable.
      }
    }
    render();
  });

  const makeRewards = () => {
    const copy = rewardsByLocale[locale];
    rewardOverlay = document.createElement('div');
    rewardOverlay.id = 'esthe-halloween-reward-overlay';
    rewardOverlay.hidden = true;
    rewardOverlay.innerHTML = `
      <div id="esthe-halloween-reward-dialog" role="dialog" aria-modal="true" aria-labelledby="esthe-halloween-reward-title">
        <div class="esthe-halloween-reward-image" aria-hidden="true"></div>
        <div class="esthe-halloween-reward-content">
          <h2 class="esthe-halloween-reward-title" id="esthe-halloween-reward-title"></h2>
          <p class="esthe-halloween-reward-description"></p>
          <div class="esthe-halloween-reward-code">ED10</div>
        </div>
        <button class="esthe-halloween-reward-close" type="button" aria-label="">
          <svg role="img" width="32" height="32" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="10" cy="10" r="9.5" fill="rgba(255,255,255,1)" stroke="rgba(255,255,255,0)"></circle>
            <path d="M6 6L14 14M6 14L14 6L6 14Z" stroke="rgba(55,63,71,1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
      </div>`;
    rewardOverlay.querySelector('.esthe-halloween-reward-title').textContent = copy.title;
    rewardOverlay.querySelector('.esthe-halloween-reward-description').textContent = copy.description;
    rewardOverlay.querySelector('.esthe-halloween-reward-image').style.backgroundImage =
      `url("${rewardImageByLocale[locale]}")`;
    const close = rewardOverlay.querySelector('.esthe-halloween-reward-close');
    close.setAttribute('aria-label', copy.close);
    close.addEventListener('click', closeRewards);
    rewardOverlay.addEventListener('click', (event) => {
      if (event.target === rewardOverlay) closeRewards();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !rewardOverlay.hidden) closeRewards();
    });
    document.body.appendChild(rewardOverlay);
  };

  const mount = () => {
    if (document.getElementById('esthe-halloween-persistent-teaser')) return;
    makeRewards();
    button = document.createElement('button');
    button.id = 'esthe-halloween-persistent-teaser';
    button.type = 'button';
    button.setAttribute('aria-label', form.label);
    const label = document.createElement('span');
    label.textContent = form.label;
    button.appendChild(label);
    button.addEventListener('click', () => {
      if (submitted) {
        openRewards();
        return;
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', form.id]);
    });
    document.body.appendChild(button);
    fitLabel = () => {
      if (button.hidden) return;
      const textWidth = label.scrollWidth;
      if (!textWidth) return;
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      const style = window.getComputedStyle(button);
      const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      button.style.height = mobile ? `${Math.ceil(textWidth + padding)}px` : '';
      const available = Math.max(1, button.clientHeight - padding);
      const scale = textWidth > available ? available / textWidth : 1;
      label.style.setProperty('--esthe-teaser-text-scale', String(scale));
    };
    fitLabel();
    window.addEventListener('resize', fitLabel);
    document.fonts?.ready.then(fitLabel);
    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
